import { Html5QrcodeScanner } from 'html5-qrcode';
import React, { useEffect, useState } from 'react';


export function QRCodeComponent(props) {
    console.log("Workout props: ", props);
    const [ScanResult, setScanResult] = useState(null);


    useEffect(() => {
        console.log("start effect")
        const scanner = new Html5QrcodeScanner('reader', {
            qrbox: {
                width: 500,
                height: 500
            },
            fps: 1,
        });

        scanner.render(success, error);

        function success(result) {
            scanner.clear();
             // Return the result to invoking parent component
            props.handleQRCode(result)
        }

        function error(err) {
            console.log({err})
        }

    }, []);

    //qrCodeReader.startCapture(videoElement)
    console.log("gets here")
    return (
        <div>
            <div id="reader"></div>
        </div>
    
    )
}
